import React, { PureComponent } from "react";
import {
  LoginCard,
  ButtonWrapper,
  Input,
  Form,
  Label,
  InputGroup,
  FormGroup,
  Button,
  LinkWrapper,
  ActionWrapper,
  FooterClass,
  LoginHeadline,
  LoginDescription,
  MicrosoftButton,
} from "../styled";
import ErrorAlert from "../../components/error-alert/ErrorAlert";
import { LoginMode } from "./LoginPage";
import {
  KeycloakContextProps,
  withKeycloak,
} from "../keycloak/KeycloakProvider";

type LoginProps = {
  username: string;
  password: string;
  userNameInput: any;
  handleInputChange: (event: any) => void;
  changeLoginMode: (loginMode: LoginMode, successfullySend?: boolean) => void;
  keyPressed: (event: any) => void;
  onSignIn: (event: any) => void;
  isFetching: boolean;
  failureMessage?: string | null;
  keycloakContext?: KeycloakContextProps;
};

type LoginState = {
  isLoggingInWithKeycloak: boolean;
};

class Login extends PureComponent<LoginProps, LoginState> {
  constructor(props: LoginProps) {
    super(props);
    this.state = {
      isLoggingInWithKeycloak: false,
    };
  }

  handleLogin = () => {
    const { keycloakContext } = this.props;
    this.setState({ isLoggingInWithKeycloak: true });
    keycloakContext?.keycloak.login();
  };

  isKeycloakInitialized = () => {
    const { keycloakContext } = this.props;
    return keycloakContext?.keycloakInitialized;
  };

  render() {
    const {
      username,
      password,
      userNameInput,
      handleInputChange,
      changeLoginMode,
      isFetching,
      keyPressed,
      onSignIn,
      failureMessage,
    } = this.props;

    const { isLoggingInWithKeycloak } = this.state;

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <LoginCard>
          <LoginHeadline>Suncorp Users</LoginHeadline>
          <LoginDescription>
            Please use your email and password to log in.
          </LoginDescription>
          <Form autoComplete="off">
            <div style={{ minHeight: "150px", paddingBottom: "1rem" }}>
              <FormGroup className="form-group">
                <InputGroup>
                  <Label>EMAIL</Label>
                  <Input
                    ref={userNameInput}
                    name="username"
                    type="text"
                    value={username}
                    aria-label="Username"
                    aria-describedby="username-icon"
                    required
                    autoFocus
                    onChange={handleInputChange}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup className="form-group">
                <InputGroup>
                  <Label>PASSWORD</Label>
                  <Input
                    name="password"
                    type="password"
                    value={password}
                    aria-label="Password"
                    aria-describedby="password-icon"
                    required
                    onChange={handleInputChange}
                    onKeyPress={keyPressed}
                  />
                </InputGroup>
              </FormGroup>
            </div>
            {failureMessage && <ErrorAlert>{failureMessage}</ErrorAlert>}
            <FooterClass>
              <ActionWrapper>
                <LinkWrapper
                  onClick={() => changeLoginMode(LoginMode.ForgotPassword)}
                >
                  Forgot Password?
                </LinkWrapper>

                <ButtonWrapper>
                  <Button
                    type="button"
                    className="btn btn-primary"
                    onClick={(e: any) => onSignIn(e)}
                    disabled={username === "" || password === ""}
                  >
                    {isFetching && (
                      <div
                        className="spinner-border spinner-border-sm"
                        style={{ marginRight: "0.5rem" }}
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    )}{" "}
                    LOGIN
                  </Button>
                </ButtonWrapper>
              </ActionWrapper>
              <LinkWrapper
                onClick={() => changeLoginMode(LoginMode.SignUp)}
                style={{
                  color: "rgba(255,255,255,1)",
                  fontSize: "0.9rem",
                  paddingTop: "0.5rem",
                }}
              >
                Sign Up
              </LinkWrapper>
            </FooterClass>
          </Form>
        </LoginCard>

        <div style={{ height: "2rem" }}></div>

        <LoginCard>
          <LoginHeadline>MPS Users</LoginHeadline>
          <LoginDescription>
            Log in using your Microsoft account.
          </LoginDescription>
          <Form>
            <div
              style={{
                marginTop: "2rem",
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <MicrosoftButton
                onClick={(e: any) => {
                  this.handleLogin();
                }}
                disabled={
                  isLoggingInWithKeycloak || !this.isKeycloakInitialized()
                }
              >
                {(isLoggingInWithKeycloak || !this.isKeycloakInitialized()) && (
                  <div
                    className="spinner-border spinner-border-sm spinner"
                    role="status"
                  ></div>
                )}
                <div className="content">
                  <img
                    src="microsoft-logo.svg"
                    alt="Microsoft Logo"
                    className="icon"
                  />
                  Sign in with Microsoft
                </div>
              </MicrosoftButton>
            </div>
          </Form>
        </LoginCard>
      </div>
    );
  }
}

export default withKeycloak(Login);
